// extracted by mini-css-extract-plugin
export default {"wrapper":"headline__wrapper__hfOv5","container":"headline__container__z2aOT","title":"headline__title__ARJ8x","description":"headline__description__HXpIY"};